import { render, staticRenderFns } from "./TermsOfServiceModal.vue?vue&type=template&id=3978a6c4&scoped=true"
import script from "./TermsOfServiceModal.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceModal.vue?vue&type=script&lang=js"
import style0 from "./TermsOfServiceModal.vue?vue&type=style&index=0&id=3978a6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3978a6c4",
  null
  
)

export default component.exports